module.exports = __webpack_public_path__ + "static/media/pepe3.1c89a27f.png";